require("rangeslider.js");
require("slick-carousel");
require("jquery-inview");
require("select2")(jQuery);
const bodyScrollLock = require("body-scroll-lock");
const disableBodyScroll = bodyScrollLock.disableBodyScroll;
const enableBodyScroll = bodyScrollLock.enableBodyScroll;

// window.mobileAndTabletCheck = function () {
//   let check = false;
//   (function (a) {
//     if (
//       /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
//         a
//       ) ||
//       /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
//         a.substr(0, 4)
//       )
//     )
//       check = true;
//   })(navigator.userAgent || navigator.vendor || window.opera);
//   return check;
// };

// var getUrlParameter = function getUrlParameter(sParam) {
//   var sPageURL = window.location.search.substring(1),
//     sURLVariables = sPageURL.split("&"),
//     sParameterName,
//     i;

//   for (i = 0; i < sURLVariables.length; i++) {
//     sParameterName = sURLVariables[i].split("=");

//     if (sParameterName[0] === sParam) {
//       return sParameterName[1] === undefined
//         ? true
//         : decodeURIComponent(sParameterName[1]);
//     }
//   }
// };

function validateEmail(email) {
  var re = /\S+@\S+\.\S+/;
  return re.test(email);
}

(function ($) {
  $(function () {
    // NEW PROJECT
    if ($("body").hasClass("new-project")) {
      localStorage.clear();
      var data = { channels: [] };
      localStorage.setItem("data", JSON.stringify(data));
      localStorage.setItem("step", 0);

      // STEPPER
      $(".step-trigger").on("click", function () {
        var index = $(this).data("index");
        $(".step-trigger").removeClass("active");
        $(this).addClass("active");
        $(".step").removeClass("active");
        $("#step_" + index).addClass("active");
      });

      // STEP NEXT
      $(".step .btn").on("click", function (e) {
        e.preventDefault();

        var index = $(this).parents(".step").data("index");
        // console.log(index);

        if (index == 5) {
          var check = true;
          $('.step.active input[type="checkbox"]').each(function () {
            if ($(this).prop("required") && !$(this).prop("checked")) {
              check = false;
              $(this).parent().addClass("error");
            } else {
              data[$(this).attr("name")] = $(this).prop("checked");
              $(this).parent().removeClass("error");
            }
          });
          if (!check) {
            return false;
          }
          localStorage.setItem("data", JSON.stringify(data));

          if (
            JSON.parse(localStorage.getItem("data")).channels.length == 0 ||
            JSON.parse(localStorage.getItem("data")).privacy_openai != true
          ) {
            if (JSON.parse(localStorage.getItem("data")).channels.length == 0) {
              $(".choices").addClass("error");
            }
            if (
              JSON.parse(localStorage.getItem("data")).privacy_openai != true
            ) {
              $(".step.active .privacy label").addClass("error");
            }
          } else {
            //Last Step
            var post_data = JSON.parse(localStorage.getItem("data"));
            var url = $("#save_url").val();
            console.log(post_data);
            $(
              "#step_" + index + ", .step-trigger[data-index=" + index + "]"
            ).removeClass("active");
            $("#result_report").hide();
            $.ajax({
              url: url,
              type: "POST",
              data: post_data,
              beforeSend: function () {
                $("#loading-email").html(post_data.email);
                $("#loading").addClass("active");
              },
              success: function (data) {
                // console.log(data);
                if (data.db_errors == null && data.mail_errors == null) {
                  $("#result_ai").html(data.ai_result);
                  $("#result_usermail").html(post_data.email);
                  $("#result_report").show();
                } else {
                  $("#result_ai").html(
                    data.ai_result +
                      "<br/><hr><br/>" +
                      data.db_errors +
                      "<br/><hr><br/>" +
                      data.mail_errors
                  );
                }
                $("main").addClass("result");
                $("#result").addClass("active");
                $(".wrapper, .stepper, .info-mobile").hide();
                localStorage.clear();
              },
              error: function (request, status, error) {
                $("#result").addClass("active");
                $("#result_ai").html(request.responseText);
                $("main").addClass("result");
                $(".wrapper, .stepper").hide();
                console.log(request, status, error);
              },
              // timeout: 0,
            });

            $(".stepper").addClass("completed");
          }
        } else {
          // Steps 0-4

          var next = index + 1;
          var check = true;

          // SAVE DATA IN LOCAL STORAGE
          $(".step.active input").each(function () {
            if ($(this).prop("required") && $(this).val() == "") {
              check = false;
              $(this).addClass("error");
            } else if (
              $(this).attr("type") == "email" &&
              !validateEmail($(this).val())
            ) {
              check = false;
              $(this).addClass("error");
            } else {
              // check = true;
              data[$(this).attr("name")] = $(this).val();
              $(this).removeClass("error");
            }
          });
          $(".step.active select").each(function () {
            if ($(this).prop("required") && $(this).val() == "") {
              check = false;
              $(this).addClass("error");
            } else {
              data[$(this).attr("name")] = $(this).val();
              $(this).removeClass("error");
            }
          });
          $(".step.active textarea").each(function () {
            if ($(this).prop("required") && $(this).val() == "") {
              check = false;
              $(this).addClass("error");
            } else {
              data[$(this).attr("name")] = $(this).val();
              $(this).removeClass("error");
            }
          });
          $('.step.active input[type="checkbox"]').each(function () {
            if ($(this).prop("required") && !$(this).prop("checked")) {
              check = false;
              $(this).parent().addClass("error");
            } else {
              data[$(this).attr("name")] = $(this).prop("checked");
              $(this).parent().removeClass("error");
            }
          });

          if (!check) {
            return false;
          }

          localStorage.setItem("data", JSON.stringify(data));
          localStorage.setItem("step", next);

          // CHANGE STEP
          $(
            "#step_" + index + ", .step-trigger[data-index=" + index + "]"
          ).removeClass("active");
          $(
            "#step_" + next + ", .step-trigger[data-index=" + next + "]"
          ).addClass("active");
        }
      });

      // STEP PREV
      $(".step .back").on("click", function (e) {
        e.preventDefault();
        var index = $(this).parents(".step").data("index");
        var prev = index - 1;
        $(
          "#step_" + index + ", .step-trigger[data-index=" + index + "]"
        ).removeClass("active");
        $(
          "#step_" + prev + ", .step-trigger[data-index=" + prev + "]"
        ).addClass("active");
      });

      //CHOICES COMPONENT
      $(".choice").on("click", function () {
        $(".choices").removeClass("error");
        $(this).toggleClass("selected");
        if ($(this).hasClass("selected")) {
          data.channels.push($(this).data("val"));
        } else {
          var index = data.channels.indexOf($(this).data("val"));
          if (index > -1) {
            data.channels.splice(index, 1);
          }
        }
        localStorage.setItem("data", JSON.stringify(data));
      });
    }

    // PROJECT
    if ($("body").hasClass("project")) {
      var data = {};
      localStorage.setItem("data", JSON.stringify(data));
      localStorage.setItem("step", 0);

      $("#step_0 .btn").on("click", async function (e) {
        e.preventDefault();
        localStorage.clear();
        var project_url = $('input[name="project_url"]').val();
        if (project_url != "") {
          var project_url_domain = new URL(project_url);
          project_url_domain = project_url_domain.hostname.replace("www.", "");
          var validUrl = await checkProjectUrl(project_url);
        }
        var email = $('input[name="email"]').val();
        var privacy = $('input[name="privacy"]').prop("checked");

        if (
          project_url == "" ||
          project_url_domain != "produzionidalbasso.com" ||
          validUrl == false ||
          email == "" ||
          validateEmail(email) != true ||
          privacy == false
        ) {
          e.preventDefault();
          if (
            project_url == "" ||
            project_url_domain != "produzionidalbasso.com"
          ) {
            $('input[name="project_url"]').addClass("error");
            $(".valid-url-error").show();
          } else {
            //$('input[name="project_url"]').removeClass('error');

            if (validUrl == false) {
              //if is not a valid project url
              $('input[name="project_url"]').addClass("error");
              $(".valid-url-error").show();
            } else {
              $('input[name="project_url"]').removeClass("error");
              $(".valid-url-error").hide();
            }
          }

          if (email == "" || validateEmail(email) != true) {
            $('input[name="email"]').addClass("error");
            $(".valid-email-error").show();
          } else {
            $('input[name="email"]').removeClass("error");
            $(".valid-email-error").hide();
          }
          if (privacy == false) {
            $('input[name="privacy"]').parent().addClass("error");
          } else {
            $('input[name="privacy"]').parent().removeClass("error");
          }
        } else {
          $('input[name="project_url"]').removeClass("error");
          $('input[name="privacy"]').parent().removeClass("error");
          $('input[name="email"]').removeClass("error");
          $(".valid-url-error").hide();
          $(".valid-email-error").hide();
          data["email"] = email;
          data["project_url"] = project_url;
          data["privacy"] = privacy;
          localStorage.setItem("data", JSON.stringify(data));
          localStorage.setItem("step", 1);
          $('#step_0, .step-trigger[data-index="0"]').removeClass("active");
          $('#step_1, .step-trigger[data-index="1"]').addClass("active");

          /*
            if(project_url.slice(-1) == '/') {
              project_url = project_url.slice(0, -1);
            }
            var parts = project_url.split('/');
   
            var project_slug = parts.at(-1);

            var api_url = $("#api_url").val();
            var post_data = {
              'project_slug': project_slug,
            };

            // AJAX CALL
            $.ajax({
              url: api_url ,
              type: "POST",
              dataType: "json",
              data: post_data,
              beforeSend: function () {
                
              },
              success: function (data) {
               $('#project_title').html(data['title']);
              },
              error: function (request, status, error) {
                console.log(request, status, error);
              },
              // timeout: 0,
            }); 

            */
        }
      });

      $("#step_1 .request-type-btn").on("click", function (e) {
        e.preventDefault();

        var request_type = $(this).attr("data-request-type");
        data["request_type"] = request_type;
        data["project_title"] = $("#project_title").html();
        localStorage.setItem("data", JSON.stringify(data));

        // AJAX CALL
        //Last Step
        var post_data = JSON.parse(localStorage.getItem("data"));
        var url = $("#save_url_project").val();

        if (request_type == "press_release") {
          var tyMessage =
            "Nell'arco di qualche minuto riceverai una email con una proposta di comunicato stampa per il tuo progetto " +
            data["project_title"];
          var tyP =
            "Stiamo elaborando il tuo report grazie ad uno speciale algoritmo di PDB in dialogo con l’Intelligenza Artificiale.<br><strong>Verifica sempre le informazioni e valutane bene il contenuto prima di procedere alla diffusione.</strong>";
        } else if (request_type == "social") {
          var tyMessage =
            "Nell'arco di qualche minuto riceverai una email con una proposta di testi utili per la comunicazione sui social del tuo progetto " +
            data["project_title"];
          var tyP =
            "Stiamo elaborando il tuo report grazie ad uno speciale algoritmo di PDB in dialogo con l’Intelligenza Artificiale.<br><strong>Verifica sempre le informazioni e valutane bene il contenuto prima di procedere alla pubblicazione.</strong>";
        } else if (request_type == "personas") {
          var tyMessage =
            "Nell'arco di qualche minuto riceverai una email con il report richiesto!<br>Progetto: " +
            data["project_title"];
          var tyP =
            "Stiamo elaborando il tuo report grazie ad uno speciale algoritmo di PDB in dialogo con l’Intelligenza Artificiale.<br><strong>Verifica sempre le informazioni e valutane bene il contenuto prima di procedere all’utilizzo di questi dati.</strong>";
        } else if (request_type == "description") {
          var tyMessage =
            "Nell'arco di qualche minuto riceverai una email con una proposta di piano editoriale per il tuo progetto " +
            data["project_title"];
          var tyP =
            "Stiamo elaborando il tuo report grazie ad uno speciale algoritmo di PDB in dialogo con l’Intelligenza Artificiale.<br><strong>Verifica sempre le informazioni e valutane bene il contenuto prima di procedere alle modifiche su Produzioni dal Basso.</strong>";
        }

        $("#step_1, .step-trigger[data-index=1]").removeClass("active");
        $("#result_report").hide();
        $.ajax({
          url: url,
          // url: '#',
          type: "POST",
          data: post_data,
          beforeSend: function () {
            // $("#loading-email").html(post_data.email);
            // $("#loading").addClass("active");
            $("#ty-email").html(post_data.email);
            $("main").addClass("ty");
            $("#ty").addClass("active");
            $("#ty-message").html(tyMessage);
            $("#ty-p").html(tyP);
            $(".wrapper, .stepper, .info-mobile").hide();
            // localStorage.clear();
          },
          success: function (data) {
            // if (data.db_errors == null && data.mail_errors == null) {
            //   $("#result_ai").html(data.ai_result);
            //   $("#result_usermail").html(post_data.email);
            //   $("#result_report").show();
            // } else {
            //   $("#result_ai").html(
            //     data.ai_result +
            //       "<br/><hr><br/>" +
            //       data.db_errors +
            //       "<br/><hr><br/>" +
            //       data.mail_errors
            //   );
            // }
            // $("main").addClass("result");
            // $("#result").addClass("active");
            // $(".wrapper, .stepper, .info-mobile").hide();
            // localStorage.clear();
          },
          error: function (request, status, error) {
            $("#result").addClass("active");
            $("#result_ai").html(request.responseText);
            $("main").addClass("result");
            $(".wrapper, .stepper").hide();
            console.log(request, status, error);
          },
          // timeout: 0,
        });

        $(".stepper").addClass("completed");
      });

      $("#step_1 .back").on("click", function (e) {
        e.preventDefault();
        $('#step_1, .step-trigger[data-index="1"]').removeClass("active");
        $('#step_0, .step-trigger[data-index="0"]').addClass("active");
      });

      $("#back_to_step_1").on("click", function (e) {
        e.preventDefault();
        $("main").removeClass("ty");
        $("#ty").removeClass("active");
        $(".wrapper, .stepper").show();
        $('#step_1, .step-trigger[data-index="1"]').addClass("active");
      });
    }

    if ($("body").hasClass("assistant")) {
      // console.log("assistant");

      // input char counter
      var inputField = $("#message");

      // Get the span element to display character count
      var charCountSpan = $("#char_count");

      var threadUrl = $('input[name="thread_url"]').val();
      function getAIResponse(message, threadId = null) {
        // console.log("getAIResponse", message, threadId);
        var post_data = {
          message: message,
          thread_id: threadId,
        };
        $.ajax({
          url: threadUrl,
          type: "POST",
          data: post_data,
          beforeSend: function () {
            $("#message").val("");
            $(".loading").appendTo(".messages").addClass("active");
            $([document.documentElement, document.body]).animate(
              {
                scrollTop: $(".loading").offset().top,
              },
              300
            );
          },
          success: function (data) {
            // console.log(data.messages[0]);
            $(".loading").removeClass("active");
            $('input[name="thread_id"]').val(data.thread_id);
            var lastMessage = data.messages[0].content[0].text.value;
            $(".messages").append(
              '<div class="message message--ai"><div class="message__text">' +
                lastMessage +
                "</div></div>"
            );

            $([document.documentElement, document.body]).animate(
              {
                scrollTop: $(".message").last().offset().top,
              },
              300
            );

            $(".loading").appendTo(".messages");
          },
          error: function (request, status, error) {
            console.log(request, status, error);
          },
          // timeout: 0,
        });
      }

      // on load
      var message = $(".message--user").last().find(".message__text").text();
      // console.log(message);
      getAIResponse(message);

      // after click enter on keyboard on input#message
      $("#message").on("keyup", function (e) {
        if (e.keyCode == 13) {
          var message = $(this).val();
          $(".messages").append(
            '<div class="message message--user"><div class="message__text">' +
              message +
              "</div></div>"
          );
          $(".messages").scrollTop($(".messages")[0].scrollHeight);
          var thread_id = $('input[name="thread_id"]').val();
          getAIResponse(message, thread_id);
          charCountSpan.text(0);
        }
      });

      $(".send").on("click", function (e) {
        e.preventDefault();
        var message = $("#message").val();
        $(".messages").append(
          '<div class="message message--user"><div class="message__text">' +
            message +
            "</div></div>"
        );
        $(".messages").scrollTop($(".messages")[0].scrollHeight);
        var thread_id = $('input[name="thread_id"]').val();
        getAIResponse(message, thread_id);
        charCountSpan.text(0);
      });

      // Attach an input event listener to the input field
      inputField.on("input", function () {
        // Get the current value of the input field
        var inputValue = inputField.val();
        // Get the length of the input value (number of characters)
        var charLength = inputValue.length;
        // Update the character count in the span element
        charCountSpan.text(charLength);
      });
    }

    // Check url function
    async function checkProjectUrl(project_url) {
      if (project_url.slice(-1) == "/") {
        project_url = project_url.slice(0, -1);
      }
      var parts = project_url.split("/");

      var project_slug = parts.at(-1);

      //console.log(project_slug);

      if (
        !project_slug ||
        project_slug == "" ||
        project_slug == "project" ||
        project_slug == "www.produzionidalbasso.com" ||
        project_slug == "produzionidalbasso.com"
      ) {
        return false;
      }

      var api_url = $("#api_url").val();
      var post_data = {
        project_slug: project_slug,
      };

      // AJAX CALL
      try {
        const result = await $.ajax({
          url: api_url,
          type: "POST",
          dataType: "json",
          data: post_data,
          beforeSend: function () {},
          success: function (data) {},
          error: function (request, status, error) {
            console.log(request, status, error);
            return false;
          },
          // timeout: 0,
        });
        if (result["title"]) {
          $("#project_title").html(result["title"]);
          return true;
        } else {
          return false;
        }
      } catch (error) {
        console.error(error);
      }
    }
  });
})(jQuery);
